import { Alert, type AlertProps, Icon } from '@sr/ui-library';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const AlertOnboarding = ({ ...props }: AlertProps) => {
  const { pathname, state } = useLocation();

  const [showOnboardingAlert, setShowOnboardingAlert] = useState(false);

  useEffect(() => {
    if (state?.from === 'onboarding') window.scrollTo(0, 0);

    setShowOnboardingAlert(state?.from === 'onboarding');
  }, [state?.from, pathname]);

  if (!showOnboardingAlert) return null;

  return (
    <Alert
      title={state?.withBankDetails ? 'Onboarding successful!' : ''}
      variant={state?.withBankDetails ? 'success' : 'warning'}
      {...props}
    >
      {state?.withBankDetails
        ? 'Now, sit back and relax. We will notify you via email as soon as you receive a payment!'
        : 'Looks like you have skipped adding your bank account details. To avoid delays in payment, please add it as soon as you can.'}
      {/* @TODO This Icon needs to be replaced for Action Button. 
      Note: Please do not copy this pattern. */}
      <Icon
        className="absolute right-4 top-1/2 h-4 w-4 -translate-y-1/2 drop-shadow-lg"
        icon="x"
        onClick={() => {
          setShowOnboardingAlert(false);
          history.replaceState({}, 'undefined');
        }}
      />
    </Alert>
  );
};
